import { Select } from "../../components/ui/form";
import { daysAgo, isoDay } from "../../lib/format";

export interface DateRange {
  from: string;
  to: string;
}

export const PRESETS = [7, 14, 30, 90] as const;

export function resolveRange(search: { from?: string; to?: string }): DateRange {
  return { from: search.from ?? daysAgo(29), to: search.to ?? isoDay(new Date()) };
}

export function RangePicker({
  range,
  onChange,
}: {
  range: DateRange;
  onChange: (range: DateRange) => void;
}) {
  const days = Math.round((Date.parse(range.to) - Date.parse(range.from)) / 86_400_000) + 1;
  return (
    <Select
      aria-label="Date range"
      value={PRESETS.includes(days as (typeof PRESETS)[number]) ? days : ""}
      onChange={(event) =>
        onChange({ from: daysAgo(Number(event.target.value) - 1), to: isoDay(new Date()) })
      }
    >
      {PRESETS.map((preset) => (
        <option key={preset} value={preset}>
          Last {preset} days
        </option>
      ))}
      {!PRESETS.includes(days as (typeof PRESETS)[number]) && <option value="">Custom</option>}
    </Select>
  );
}
